import { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";

import Loading from "../../components/Loading";
import Menu from "../../components/Menu";
import api from "../../services/api";
import { InputNumber } from "primereact/inputnumber";

export function ArtigoTempo() {
    const [artigos, setArtigos] = useState([]);
    const [data, setData] = useState([]);
    const [form, setForm] = useState({
        id: null,
        artigo: "",
        tempo: "",
        parada_id: 1
    });

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const getData = useCallback(() => {
        setIsLoading(true);
        api.get("cadastros/artigo-tempo").then((response) => {
            setArtigos(response.data.artigos);
            setData(response.data.dados);

            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }, []);

    const handleSubmit = _ => {
        if(isEditing && form.id !== null) {
            setIsLoading(true);
            api.put(`cadastros/artigo-tempo/${form.id}/update`, form).then((response) => {
                getData();
                setIsEditing(false);
                setIsLoading(false);
                
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        } else {
            setIsLoading(true);
            api.post(`cadastros/artigo-tempo`, form).then((response) => {
                getData();
                setIsLoading(false);
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            })
        }
    }

    const handleEdit = rowData => {
        setIsEditing(true);
        setIsVisible(true);
        setForm({
            id: rowData.id,
            artigo: rowData.artigo,
            parada_id: rowData.parada_id,
            tempo: rowData.tempo,
        });
    }

    const handleDelete = rowData => {
        confirmDialog({
            acceptClassName: "p-button-danger",
            acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary",
            rejectLabel: "Cancelar",
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro?",
            accept: () => {
                setIsLoading(true);
                api.delete(`cadastros/artigo-tempo/${rowData.id}/delete`).then((response) => {
                    getData();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch((error) => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    const onHide = _ => {
        if(isEditing) {
            setForm({
                id: null,
                artigo: "",
                tempo: "",
                parada_id: ""
            });
        }
        setIsEditing(false);
        setIsVisible(false);
    }

    const onShow = _ => setIsVisible(true);

    useEffect(() => {
        getData()
    }, [getData]);

    if(isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Toast ref={toast} />
            <Menu />
            <Card
                className="p-m-1"
                title="Tempo Médio de Artigo - Engrupagem e Reengrupagem"
            >
                <Dialog
                    header={isEditing ? "Editar" : "Cadastrar"}
                    onHide={onHide}
                    style={{ minWidth: "30vw" }}
                    visible={isVisible}
                >
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="artigo">Artigo</label>
                            <Dropdown 
                                className="p-m-1"
                                filter
                                onChange={e => setForm({...form, artigo: e.value })}
                                options={artigos}
                                optionLabel="codigo"
                                optionValue="codigo"
                                placeholder="Escolha um dos artigos"
                                value={form.artigo}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="parada_id">Parada: </label>
                            <Dropdown
                                className="p-m-1"
                                onChange={e => setForm({...form, parada_id: e.value })}
                                options={[
                                    { label: 'Engrupagem', value: 1 },
                                    { label: 'Reengrupagem', value: 2 }
                                ]}
                                placeholder="Escolha o tipo de parada"
                                value={form.parada_id}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="tempo">Tempo: </label>
                            <InputNumber 
                                className="p-m-1"
                                onChange={e => setForm({...form, tempo: e.value })}
                                placeholder="Tempo médio"
                                value={form.tempo}
                            />
                        </div>
                        <div className="p-d-flex p-flex-row">
                            <Button className="p-button-secondary p-mr-6" label="Cancelar" onClick={onHide} />
                            <Button className="p-button-success" label="Salvar" onClick={handleSubmit} />
                        </div>
                    </div>
                </Dialog>   

                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button 
                        className="p-m-2"
                        icon="pi pi-plus"
                        onClick={() => onShow()}
                    />
                </div>

                <DataTable
                    className="p-m-1"
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    paginator
                    rows={15}
                    size="small"
                    value={data}
                >
                    <Column header="Artigo" field="artigo" sortable />
                    <Column header="Parada" field="paradaf" sortable />
                    <Column header="Tempo" field="tempo" sortable />
                    <Column header="Data" field="dataf" sortable />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button 
                                className="p-button-primary p-m-1"
                                icon="pi pi-pencil"
                                onClick={() => handleEdit(rowData)}
                                title="Clique para excluir esse registro"
                            />
                            <Button 
                                className="p-button-danger p-m-1"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData)}
                                title="Clique para excluir esse registro"
                            />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}